// Enums com labels amigáveis em pt-BR. Evita expor termos técnicos
// (PAID, PENDING, CANCELED, REFUNDED, CONSUMER, RESELLER, ACTIVE…) na UI.
//
// Cada mapa cobre tanto o formato canônico do backend quanto aliases
// comuns (UPPERCASE, lowercase) pra ser defensivo com payloads variados.
// Use `formatEnum(MAP, value)` pra obter o label, ou `STATUS_LABEL(value)`
// helpers específicos pra render direto.

// Pedidos — buckets simplificados (Seção 2.8.1 da Doc) + status granulares.
export const ORDER_STATUS_LABELS = {
  // Buckets uppercase (vindos do backend mapStatusToBucket)
  PENDING: 'Pendente',
  PAID: 'Pago',
  CANCELED: 'Cancelado',
  REFUNDED: 'Reembolsado',
  // Status granulares (lowercase, valores do DB)
  pending: 'Aguardando pagamento',
  awaiting_approval: 'Aguardando aprovação',
  approved: 'Aprovado',
  paid: 'Pago',
  shipped: 'Enviado',
  delivered: 'Entregue',
  cancelled: 'Cancelado',
  rejected: 'Rejeitado',
  refunded: 'Reembolsado',
};

export const PAYMENT_STATUS_LABELS = {
  pending: 'Pendente',
  confirmed: 'Confirmado',
  paid: 'Pago',
  received: 'Recebido',
  overdue: 'Atrasado',
  cancelled: 'Cancelado',
  refunded: 'Estornado',
  failed: 'Falhou',
};

// Status de loja (Seção 2 da Doc).
export const STORE_STATUS_LABELS = {
  active: 'Ativa',
  ACTIVE: 'Ativa',
  trial: 'Em teste',
  TRIAL: 'Em teste',
  suspended: 'Suspensa',
  SUSPENDED: 'Suspensa',
  inactive: 'Inativa',
  INACTIVE: 'Inativa',
  blocked: 'Bloqueada',
  BLOCKED: 'Bloqueada',
  pending: 'Pendente',
};

// Status de usuário.
export const USER_STATUS_LABELS = {
  active: 'Ativo',
  ACTIVE: 'Ativo',
  inactive: 'Inativo',
  INACTIVE: 'Inativo',
  suspended: 'Suspenso',
  SUSPENDED: 'Suspenso',
  blocked: 'Bloqueado',
  BLOCKED: 'Bloqueado',
  pending: 'Pendente',
};

// Roles (Seção 1.3 da Doc) — global e per-store. Labels foram escolhidos pra
// serem auto-explicativos em qualquer contexto (lista de usuários, modal de
// novo cadastro, badges de papel).
export const ROLE_LABELS = {
  // users.role (global)
  platform_admin: 'Administrador Reviter',
  store_owner: 'Equipe da loja',
  reseller: 'Revendedor',
  client: 'Cliente',
  // Aliases canônicos da Doc (uppercase)
  REVITER: 'Administrador Reviter',
  MANAGER: 'Equipe da loja',
  RESELLER: 'Revendedor',
  CONSUMER: 'Cliente',
  // storeUsers.roleInStore (per-store)
  owner: 'Dono da loja',
  staff: 'Equipe',
};

// Modelo de negócio da loja.
export const BUSINESS_TYPE_LABELS = {
  seller: 'Venda direta',
  reseller: 'Com revendedores',
  catalog: 'Catálogo (WhatsApp)',
};

// Tipo de plano.
export const PLAN_TYPE_LABELS = {
  DEFAULT: 'Padrão',
  CUSTOM: 'Customizado',
};

// Helper genérico — retorna o label se existir, senão devolve o valor
// original (defensivo: não quebra se o backend mandar um enum novo).
export function formatEnum(map, value) {
  if (value == null) return '';
  return map[value] ?? map[String(value).toLowerCase()] ?? map[String(value).toUpperCase()] ?? value;
}

// Atalhos por domínio — preferir esses pra render direto.
export const formatOrderStatus = (v) => formatEnum(ORDER_STATUS_LABELS, v);
export const formatPaymentStatus = (v) => formatEnum(PAYMENT_STATUS_LABELS, v);
export const formatStoreStatus = (v) => formatEnum(STORE_STATUS_LABELS, v);
export const formatUserStatus = (v) => formatEnum(USER_STATUS_LABELS, v);
export const formatRole = (v) => formatEnum(ROLE_LABELS, v);
export const formatBusinessType = (v) => formatEnum(BUSINESS_TYPE_LABELS, v);
export const formatPlanType = (v) => formatEnum(PLAN_TYPE_LABELS, v);
